import React from "react";
import { Button } from "@material-ui/core";

import { LoginContainer, LoginInnerContainer } from "./Login.elements";

function Login({ login }) {
  return (
    <LoginContainer>
      <LoginInnerContainer>
        <img
          src="https://cdn.mos.cms.futurecdn.net/SDDw7CnuoUGax6x9mTo7dd.jpg"
          alt="slack"
        />
        <h1>Sign in to the Luka's Slack</h1>
        <p>lukasslack.slack.com</p>

        <Button onClick={login}>Sign in with Google</Button>
      </LoginInnerContainer>
    </LoginContainer>
  );
}

export default Login;
